/**
 * TypewriterText - Letter-by-letter reveal animation
 * Respects prefers-reduced-motion
 */

import { motion, useReducedMotion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface TypewriterTextProps {
  text: string;
  className?: string;
  staggerDelay?: number; // Delay between each character (in seconds)
}

export function TypewriterText({ text, className, staggerDelay = 0.012 }: TypewriterTextProps) {
  const shouldReduceMotion = useReducedMotion();
  const characters = text.split('');

  // If reduced motion, render text normally
  if (shouldReduceMotion) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span className={cn('inline-block', className)}>
      {characters.map((char, index) => (
        <motion.span
          key={index}
          initial={{ opacity: 0, x: -2 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{
            duration: 0.3,
            delay: index * staggerDelay,
            ease: [0.16, 1, 0.3, 1],
          }}
          className="inline-block"
        >
          {char === ' ' ? '\u00A0' : char}
        </motion.span>
      ))}
    </span>
  );
}

